import * as React from "react";
import { Button } from "../../buttons";

export const JobNotFoundErrorMessage = (message: string) => {

    const handleClick = () => {
        window.location.href = `/${appConfig.appName}/jobs`;
    };

    return (
        <>
            <div>{message}</div>
            <br/>
            <Button
                id="jobNotFoundErrorMessage-button"
                size="small"
                color="primary"
                type="submit"
                variant="contained"
                onClick={handleClick}
            >
                click here to browse current jobs
            </Button>
        </>
    );
};
